import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../core/design-system/components/Button';
import { Icon } from '../../../../core/design-system/components/Icon';
import './common.css';
import './WelcomeStep.css';

const WelcomeStep = ({ onComplete }) => {
  const { t } = useTranslation('onboarding');

  const handleComplete = () => {
    onComplete({});
  };

  return (
    <div className="welcome-step-container">
      <div className="welcome-features">
        <div className="feature-item">
          <Icon name="map-pin" size={24} />
          <span>{t('welcome.features.nearby')}</span>
        </div>
        <div className="feature-item">
          <Icon name="users" size={24} />
          <span>{t('welcome.features.community')}</span>
        </div>
        <div className="feature-item">
          <Icon name="calendar" size={24} />
          <span>{t('welcome.features.organize')}</span>
        </div>
      </div>
      
      <Button 
        onClick={handleComplete}
        variant="primary"
        className="step-submit-button"
      >
        {t('welcome.continue')}
      </Button>
    </div>
  );
};

export default WelcomeStep; 